<!-- 拦截规则 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">

                <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new" style="width:100%">
                    <el-tab-pane label="编辑拦截规则" name="编辑拦截规则">
                        <div class="table_content_box">
                            <el-form size="mini" :model="sendDataInfo" label-width="120px" ref="sendDataInfo"
                                label-position="right" :show-message="false">
                                <el-form-item label="规则描述" prop="ruleDesc">{{ sendDataInfo.ruleDesc }}</el-form-item>
                                <el-form-item label="参数" prop="ruleParam">
                                    <el-input type="textarea" rows="5" v-model="sendDataInfo.ruleParam" size="mini"
                                        :disabled="sendDataInfo.ruleParam == null"></el-input>
                                </el-form-item>
                                <el-form-item label="是否为空拦截" prop="isNull">
                                    <el-radio-group v-model="sendDataInfo.isNull" size="mini"
                                        :disabled="sendDataInfo.isNull == null">
                                        <el-radio-button label="1">是</el-radio-button>
                                        <el-radio-button label="0">否</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="规则类型" prop="ruleType">
                                    <el-radio-group v-model="sendDataInfo.ruleType" size="mini">
                                        <el-radio-button label="1">开关+参数型</el-radio-button>
                                        <el-radio-button label="0">开关型</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="是否拦截" prop="ruleResult">
                                    <el-radio-group v-model="sendDataInfo.ruleResult" size="mini">
                                        <el-radio-button label="1">提醒</el-radio-button>
                                        <el-radio-button label="0">拦截</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="是否启用" prop="isEnable">
                                    <el-radio-group v-model="sendDataInfo.isEnable" size="mini">
                                        <el-radio-button label="1">启用</el-radio-button>
                                        <el-radio-button label="0">停用</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                                <!-- <el-form-item label="单位" prop="unit" :rules="[{required: true, trigger: ['blur', 'change']}]">
                  <el-input v-model.trim="sendDataInfo.unit" :maxlength="$store.state.inputLength" placeholder="选择完归属自动生成"></el-input>
                </el-form-item>
                <el-form-item label="单位地址" prop="address" :rules="[{required: true, trigger: ['blur', 'change']}]">
                  <el-input v-model.trim="sendDataInfo.address" :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="contact" :rules="[{required: true, trigger: ['blur', 'change']}]">
                  <el-input v-model.trim="sendDataInfo.contact" :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone" :rules="[{required: true, trigger: ['blur', 'change']}]">
                  <el-input v-model.trim="sendDataInfo.phone" :maxlength="$store.state.inputLength"></el-input>
                </el-form-item> -->
                            </el-form>
                        </div>
                    </el-tab-pane>
                </el-tabs>

                <!-- 页脚 -->
                <div style="text-align: center;">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: 'interceptRuleAction',
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            showTabs: "编辑拦截规则",
            isLoaded: false,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                // address: "", // 	单位地址
                // contact: "", // 	联系人
                // phone: "", // 	联系电话
                // unit: "", // 	单位
                // id: "",
            },
            allDepartmentList: [],
            selectDepartmentPath: []

        };
    },
    //方法集合
    methods: {
        initActionBox(formName) {
            if (this.dataActionBox.actionType != 0) {
                this.init();
                this.$refs[formName].resetFields();
                this.$emit('drawerCancel', 0)
                return
            }
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit('drawerCancel', 0)
                    this.$refs[formName].resetFields();
                })
                .catch(() => { });
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.dataActionBox.actionType = 0;
        },

        async openBox(cate, sendDataInfo, oldData = '') {
            this.init()
            if (cate == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
            } else {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
            }
            this.dataActionBox.actionType = cate
            this.dataActionBox.showStatus = true
        },

        async sendDataAction() {
            if (this.sendDataInfo.unit == '') {
                this.$message({
                    message: '请填写单位',
                    type: 'error'
                });
                return false
            }
            if (this.sendDataInfo.address == '') {
                this.$message({
                    message: '请填写单位地址',
                    type: 'error'
                });
                return false
            }
            if (this.sendDataInfo.contact == '') {
                this.$message({
                    message: '请填写联系人',
                    type: 'error'
                });
                return false
            }
            if (this.sendDataInfo.phone == '') {
                this.$message({
                    message: '请填写联系电话',
                    type: 'error'
                });
                return false
            }
            var sendDataInfo = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (this.dataActionBox.actionType == 0) {
                // var responseData = await this.$http.addDepartment(sendDataInfo)
            } else {
                var responseData = await this.$http.setRoulesList(sendDataInfo)
            }
            if (responseData.status == 200) {
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$emit('drawerCancel', 1)

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            var params = this.actionData;
            this.openBox(params.cate, params.sendDataInfo, params.oldData);
            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

.el-drawer {
    outline: none;
}

.foot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #fff;
    padding: 14px 0;
    z-index: 999;
}

.foot .el-form {
    margin-left: 20px;
}

.foot .el-form .el-form-item {
    margin-bottom: 0;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>